import React from 'react'
import { Routes, Route, } from 'react-router-dom'

import Header from './components/layouts/Header'
import Footer from './components/layouts/Footer'

import Home from "./components/pages/HomeComponent"
import Logout from "./components/pages/auth/LogoutComponent"
import Register from "./components/pages/auth/RegisterComponent"
import NotFound from "./components/pages/http/NotFoundComponent"
import Settings from "./components/pages/account/SettingsComponent"
import PaymentMethods from "./components/pages/account/paymentMethods/PaymentMethodsComponent"
import AddPaymentMethod from "./components/pages/account/paymentMethods/AddPaymentMethodComponent"
import GamesComponent from "./components/pages/GamesComponent"
import AboutComponent from './components/pages/AboutComponent'

import { url } from './utils/config'
import AuthRoute from './AuthRoute'
import PrivacyPolicyComponent from './components/pages/PrivacyPolicyComponent'
import LosMuertosDownloadComponent from './components/pages/download/LosMuertosDownloadComponent'

export default () => {
  return (
    <main className="main" id="top">
      <Header/>
      <Routes>
        <Route path={url("/")} element={<Home />}/>
        <Route path={url("/user/logout")} element={<Logout />}/>
        <Route path={url("/user/register")} element={<Register />}/>
        <Route path={url("/games")} element={<GamesComponent />}/>
        <Route path={url("/about")} element={<AboutComponent />}/>
        <Route path={url("/privacy-policy")} element={<PrivacyPolicyComponent />}/>
        <Route element={<AuthRoute/>}>
          <Route path={url("/user/settings")} element={<Settings />}/>
          <Route path={url("/user/payment-methods")} element={<PaymentMethods />}/>
          <Route path={url("/user/payment-methods/add")} element={<AddPaymentMethod />}/>
          <Route path={url("/downloads/los-muertos-game")} element={<LosMuertosDownloadComponent />}/>
        </Route>
        <Route path={url("*")} element={<NotFound />}/>
      </Routes>
      <Footer/>
    </main>
  )
}
